export default __webpack_public_path__ + "static/media/Accessible_Games_for_Blind_Children_Empo-1.c361520f.pdf";